import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2026-02-18 17:49:02 +0100 (Wed, 18 Feb 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 160809 $
//  Purpose   : webpack entrypoint, uix package (exposes global vl.*)
// =============================================================================
// ---Polyfills
// should be done by babel: https://stackoverflow.com/a/57319583
//~ import 'core-js/stable' // importing via webpack entrypoint increases bundle size (20kB)
// https://web.dev/vitals/
import { registerWebVitals } from 'uix/utils/vitals';
registerWebVitals();
// maybe useful
//~ Error.stackTraceLimit = Infinity
// ---Third-party imports
import React from 'react'; // this is not optional!
import ReactDOM from 'react-dom';
// ---Framework imports
import { dict, mapItems } from 'ldash';
import log from 'uix/logging';
import { BrowserApp, ExpressApp } from 'uix/app';
import { configureBrowserStore, configureExpressStore } from 'uix/store';
import { JSONTree } from 'uix/chunks';
import * as unconnectedActions from 'uix/actions';
import { uix, Actions, MountedParts as parts, Sel, Views } from 'uix/registries';
import { rootSaga } from 'uix/sagas';
import { registerCSSVariables } from 'uix/styles/variables';
import { set_pprint_buffer } from 'uix/utils/pprint';
let actions = Actions;
if (process.env.UIX_ENV.includes('browser')) {
    log.info('setup CSS vars');
    registerCSSVariables();
    log.info('setup BrowserStore');
    var { store, persistor } = configureBrowserStore(rootSaga);
    log.info('mounting Browser App ...');
    let rootEl = document.getElementById('root');
    ReactDOM.render(/*#__PURE__*/ _jsx(BrowserApp, {
        store: store,
        persistor: persistor
    }), rootEl);
    let wrap = (action)=>(...args)=>store.dispatch(action(...args));
    actions = dict(mapItems(actions, (k, v)=>[
            k,
            wrap(v)
        ]));
}
const procenv = process.env;
// ---Export
// access exported attributes as global vl.* in js runtime
const getState = ()=>store.getState();
// bound selectors
// example: vl.select.i18n().getType('book')
const select = dict(mapItems(Sel, (name, f)=>[
        name,
        ()=>f(store.getState())
    ]));
// vl.pprint() is always available and shows a part with a rendered json tree for data
// raw_pprint fills a data buffer which is collected in a saga. the saga emits a pprint() action
const pprint = set_pprint_buffer;
// renderable <vl.PPrint data={data}/>
const PPrint = ({ expand, ...p })=>/*#__PURE__*/ _jsx(JSONTree, {
        shouldExpandNode: expand ? ()=>true : null,
        ...p
    });
export { log, ExpressApp, configureExpressStore, procenv, uix, getState, actions, select, parts, Views, // debug tools
pprint, PPrint,  };
